import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-hot-toast";
import Loading2 from "../../../utils/Loader/Loading2";

const ActivityRow = ({ modulesData, activityData, roleId }) => {
  const [loading, setLoading] = useState(false);

  const [m2AData, setM2AData] = useState([]);
  const [respData, setRespData] = useState();

  const [selectedActivites, setSelectedActivities] = useState([]);

  const handleCheckboxChange = (moduleId, activityId, checked) => {
    if (checked) {
      setSelectedActivities((prevSelectedActivities) => [
        ...prevSelectedActivities,
        {
          role_id: parseInt(roleId),
          module_id: moduleId,
          activity_id: activityId,
        },
      ]);
    } else {
      setSelectedActivities((prevSelectedActivities) =>
        prevSelectedActivities.filter(
          (item) =>
            !(item.module_id === moduleId && item.activity_id === activityId)
        )
      );
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    let url = `${process.env.REACT_APP_API_BASE_URL}/role-permission/save/${roleId}`;
    axios
      .post(
        url,
        { selectedActivites },
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `Bearer ${localStorage?.getItem("jwtToken")}`,
          },
        }
      )
      .then((response) => {
        console.log("data sent", response.data);
        setRespData(respData);
        toast.success("Successfully updated!");
      })
      .catch((error) => {
        console.log(error);
      });

    // console.log(selectedActivites);

    // window.location.reload(false);
  };

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/role-permission/get/${roleId}`,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `Bearer ${localStorage?.getItem("jwtToken")}`,
          },
        }
      );
      const data = response.data;
      setSelectedActivities(data?.data || []);

      // setSelectedActivities(data.data);
    } catch (error) {
      console.log("error");
    } finally {
      setLoading(false);
    }
  };

  const getModuleToActivityData = () => {
    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}/module-to-activity`, {
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${localStorage?.getItem("jwtToken")}`,
        },
      })
      .then((response) => {
        const fetchedData = response.data.data;

        setM2AData(fetchedData);
        // console.log(fetchedData)
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    fetchData();
  }, [roleId]);

  useEffect(() => {
    getModuleToActivityData();
  }, []);

  return (
    <>
      {loading ? (
        <tr>
          <td colSpan={activityData.length + 1}>
            <Loading2 />
          </td>
        </tr>
      ) : (
        modulesData?.map((module) => (
          <tr key={module.id}>
            <th scope="row">{module.name}</th>
            {activityData.map((activity) => {
              const moduleActivity = m2AData.find(
                (item) =>
                  item.module_id === module.id &&
                  item.activity_id === activity.id
              );
              const isChecked = selectedActivites.some(
                (item) =>
                  item.module_id === module.id &&
                  item.activity_id === activity.id &&
                  item.role_id === parseInt(roleId)
              );
              if (moduleActivity) {
                return (
                  <td key={activity.id}>
                    <div className="form-check">
                      <input
                        className="form-check-input text-center"
                        type="checkbox"
                        checked={isChecked}
                        id={`activity-${activity.id}-${module.id}`}
                        onChange={(e) =>
                          handleCheckboxChange(
                            module.id,
                            activity.id,
                            e.target.checked
                          )
                        }
                      />
                      <label
                        className="form-check-label text-center"
                        htmlFor={`activity-${activity.id}-${module.id}`}
                      >
                        {activity.name}
                      </label>
                    </div>
                  </td>
                );
              } else {
                return <td key={activity.id}></td>;
              }
            })}
          </tr>
        ))
      )}
      <br />
      <button
        className="btn btn-primary btn-lg float-right"
        onClick={handleSubmit}
        type="submit"
      >
        Save
      </button>
    </>
  );
};

export default ActivityRow;
